import type { AuthService } from './interfaces/AuthService';
import type { TenantService } from './interfaces/TenantService';
import type { AppointmentService } from './interfaces/AppointmentService';
import type { AvailabilityService } from './interfaces/AvailabilityService';
import type { JobService } from './interfaces/JobService';
import type { CustomerService } from './interfaces/CustomerService';
import type { TokenService } from './interfaces/TokenService';
import type { InvoiceService } from './interfaces/InvoiceService';
import type { QuoteService } from './interfaces/QuoteService';
import type { EquipmentService } from './interfaces/EquipmentService';
import { authService } from './AuthService';
import { tenantService } from './TenantService';
import { appointmentService } from './AppointmentService';
import { availabilityService } from './AvailabilityService';
import { jobService } from './JobService';
import { customerService } from './CustomerService';
import { tokenService } from './TokenService';
import { invoiceService } from './InvoiceService';
import { quoteService } from './QuoteService';
import { equipmentService } from './EquipmentService';

export interface Services {
  auth: AuthService;
  tenant: TenantService;
  appointments: AppointmentService;
  availability: AvailabilityService;
  jobs: JobService;
  customer: CustomerService;
  tokens: TokenService;
  invoices: InvoiceService;
  quotes: QuoteService;
  equipment: EquipmentService;
}

const services: Services = {
  auth: authService,
  tenant: tenantService,
  appointments: appointmentService,
  availability: availabilityService,
  jobs: jobService,
  customer: customerService,
  tokens: tokenService,
  invoices: invoiceService,
  quotes: quoteService,
  equipment: equipmentService,
};

export function useServices(): Services {
  return services;
}
